import { AIDifficulty, ITile, PipValue, BoardEnd, IBoardTile } from '../core/types';
import { IAIStrategy } from './AIStrategy';
import { EasyStrategy } from './strategies/EasyStrategy';
import { MediumStrategy } from './strategies/MediumStrategy';
import { HardStrategy } from './strategies/HardStrategy';

/**
 * AI Controller that delegates to the appropriate strategy.
 */
export class AIEngine {
  private strategy: IAIStrategy;

  constructor(difficulty: AIDifficulty) {
    this.strategy = this.createStrategy(difficulty);
  }

  /**
   * Updates the AI difficulty.
   */
  public setDifficulty(difficulty: AIDifficulty): void {
    this.strategy = this.createStrategy(difficulty);
  }

  /**
   * Selects a play using the current strategy.
   */
  public selectPlay(hand: ITile[], leftEnd: PipValue | null, rightEnd: PipValue | null, boardTiles: IBoardTile[]): { tile: ITile; end: BoardEnd } | null {
    return this.strategy.selectTile(hand, leftEnd, rightEnd, boardTiles);
  }

  private createStrategy(difficulty: AIDifficulty): IAIStrategy {
    switch (difficulty) {
      case AIDifficulty.Easy:
        return new EasyStrategy();
      case AIDifficulty.Hard:
        return new HardStrategy();
      case AIDifficulty.Medium:
      default:
        return new MediumStrategy();
    }
  }
}
